namespace RecordShield.Administration {
    export interface QueuedSmsRow {
        Id?: number;
        PriorityId?: number;
        From?: string;
        To?: string;
        ReplyTo?: string;
        Cc?: string;
        Body?: string;
        MessageType?: number;
        CreatedOnUtc?: string;
        SentTries?: number;
        SentOnUtc?: string;
        DontSendBeforeDateUtc?: string;
        HasError?: boolean;
        Result?: string;
    }

    export namespace QueuedSmsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'From';
        export const localTextPrefix = 'Administration.QueuedSms';

        export namespace Fields {
            export declare const Id: string;
            export declare const PriorityId: string;
            export declare const From: string;
            export declare const To: string;
            export declare const ReplyTo: string;
            export declare const Cc: string;
            export declare const Body: string;
            export declare const MessageType: string;
            export declare const CreatedOnUtc: string;
            export declare const SentTries: string;
            export declare const SentOnUtc: string;
            export declare const DontSendBeforeDateUtc: string;
            export declare const HasError: string;
            export declare const Result: string;
        }

        ['Id', 'PriorityId', 'From', 'To', 'ReplyTo', 'Cc', 'Body', 'MessageType', 'CreatedOnUtc', 'SentTries', 'SentOnUtc', 'DontSendBeforeDateUtc', 'HasError', 'Result'].forEach(x => (<any>Fields)[x] = x);
    }
}
